import React from "react";
import { Box } from "@mui/material";
import { COLORS, SIZES, DetailHeaderCell } from "../SkillSheetMainSectionUi";
import SkillSheetMainWorkContent from "./SkillSheetMainWorkContent";
import SkillSheetMainSkill from "./SkillSheetMainSkill";
import SkillSheetMainAchievement from "./SkillSheetMainAchievement";

/**
 * SkillSheetMainDetailMobile
 * - モバイル専用
 */
export default function SkillSheetMainDetailMobile({
  workSections,
  skillSections,
  displayValues,
}) {
  return (
    <Box sx={{ display: "grid", gap: 1 }}>
      <Box
        sx={{
          border: `1px solid ${COLORS.border}`,
          borderRadius: `${SIZES.radius}px`,
          overflow: "hidden",
          backgroundColor: COLORS.valueBg,
        }}
      >
        {/* 業務内容 */}
        <DetailHeaderCell
          sx={{
            borderBottom: `1px solid ${COLORS.border}`,
          }}
        >
          業務内容
        </DetailHeaderCell>
        <SkillSheetMainWorkContent workSections={workSections} />

        {/* 使用技術 */}
        <DetailHeaderCell
          sx={{
            borderTop: `1px solid ${COLORS.border}`,
            borderBottom: `1px solid ${COLORS.border}`,
          }}
        >
          使用技術
        </DetailHeaderCell>
        <SkillSheetMainSkill skillSections={skillSections} />
      </Box>

      {/* 成果/アピールポイント */}
      <SkillSheetMainAchievement displayValues={displayValues} />
    </Box>
  );
}
